<template>
  <div>
    <nav aria-label="breadcrumbs" class="mt-5">
      <b-breadcrumb>
        <b-breadcrumb-item
          class="focus-only"
          v-for="breadcrumb in breadcrumbs"
          :key="breadcrumb.id"
          :text="breadcrumb.text"
          :to="breadcrumb.href"
          :active="breadcrumb.active"
        />
      </b-breadcrumb>
    </nav>
  </div>
</template>

<script>
import { Vue, Component, Prop } from 'vue-property-decorator';

@Component({
  mounted() {},
})
class BreadcrumbsHelper extends Vue {
  @Prop({ type: Array })
  breadcrumbs;
}

export default BreadcrumbsHelper;
</script>

<style scoped>
.focus-only :focus {
  outline: none;
  color: #32557f;
  text-decoration: none;
  border-bottom: 1px solid #4e97b2;
  padding-bottom: 3px;
}

a,
.breadcrumb,
.breadcrumb-item,
.breadcrumb-item.active {
  color: var(--blue-900) !important;
  li > a {
    color: var(--blue-900) !important;
  }
}

a {
  text-decoration: underline;
}

.breadcrumb-item:first-child::before {
  content: '';
}
.breadcrumb-item::before {
  content: '>>';
  font-size: 1em;
  letter-spacing: -3px;
}

.breadcrumb-item {
  letter-spacing: 0px;
  font-size: 0.9em;
}
.breadcrumb-item + .breadcrumb-item {
  padding-left: 0.25rem;
}
</style>
